module.exports = __webpack_public_path__ + "static/media/newsTwo.acb73ee1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/rowFour/newsTwo.jpg
// module id = 68
// module chunks = 0